import { format, isToday } from "date-fns";
import _ from "lodash";
import {
  getAppointmentDoctorName,
  getAppointmentPatientName,
} from "../../../helpers/utilities";
import lostImg from "../../../static/svg/lost.svg";

export function UpcomingAppointmentsEmpty({
  message = "No upcoming appointments.",
}) {
  return (
    <div className="text-center py-2">
      <img src={lostImg} width={160} height={160} alt="" />
      <p className="text-muted small mb-0 mt-2">{message}</p>
    </div>
  );
}

export function UpcomingAppointmentCard({ appointment, onClick }) {
  const patientName = getAppointmentPatientName(appointment);
  const doctorName = getAppointmentDoctorName(appointment);
  const startDate = new Date(appointment?.startDate);
  const startTime = new Date(appointment?.startTime);
  const dateLabel = isToday(startDate)
    ? "Today"
    : format(startDate, "MMM d, yyyy");
  const timeLabel = format(startTime, "h:mm a");
  const typeLabel = _.capitalize(appointment?.appointmentType || "—");

  return (
    <div
      className="py-1"
      onClick={() => onClick?.(appointment)}
      style={{ cursor: onClick ? "pointer" : undefined }}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick(appointment);
              }
            }
          : undefined
      }>
      <p className="m-0 fw-bold text-truncate">{patientName}</p>
      <p className="text-muted small mb-0">
        {dateLabel} · {timeLabel} · {typeLabel}
      </p>
      <p className="text-muted small mb-0">{doctorName}</p>
    </div>
  );
}
